import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { ContextMenu } from './context-menu';

@Directive({
  selector: '[andorContextMenuTriggerFor]',
  standalone: true,
  exportAs: 'andorContextMenuTrigger',
})
export class ContextMenuTriggerDirective {
  andorContextMenuTriggerFor = input.required<ContextMenu>();

  private _elementRef = inject(ElementRef);

  @HostListener('click')
  onClick() {
    this.andorContextMenuTriggerFor().toggle(this._elementRef.nativeElement);
  }

  closeMenu() {
    this.andorContextMenuTriggerFor().close();
  }
}
